export enum PartnerEventTabEnum {
  OVERDUE = "overdue",
  LIST = "list",
  RECURRING = "series"
}
